import { Pipe, PipeTransform } from '@angular/core';
import { formatDateSimple } from '@shared/utils';
import { of } from 'rxjs';

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
  transform(value: any): any {
    if (!value) {
      return of('');
    }

    try {
      if (typeof value === 'string' && value.includes('T')) {
        value = new Date(value);
      } else if (typeof value === 'string' && value.includes('-')) {
        // Parse MM-DD-YYYY hh:mm A format (from formateUTCtoTZ)
        // Example: "11-04-2025 06:50 AM"
        const parts = value.split(/[- :]/);
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        let hour = parts[3] ? parseInt(parts[3], 10) : 0;
        const minute = parts[4] ? parseInt(parts[4], 10) : 0;
        const ampm = parts[5] ? parts[5].toUpperCase() : '';

        // Convert 12-hour to 24-hour format
        if (ampm === 'PM' && hour !== 12) {
          hour += 12;
        } else if (ampm === 'AM' && hour === 12) {
          hour = 0;
        }

        value = new Date(year, month - 1, day, hour, minute);
      } else if (!(value instanceof Date)) {
        return of('');
      }

      const formattedValue = formatDateSimple(value, 'MM/DD/yyyy hh:mm A');
      return of(formattedValue);
    } catch (err) {
      console.error('CustomDatePipe error:', err, value);
      return of('');
    }
  }
}
